<template>
  <header class="tukave-header" role="menu">

    <div class="attachments root-item-attachments">
      <div class="single-attachment" v-for="attachment in rootItem.attachments">
        <a 
          :href="attachment.url"
          target="_blank"
        >
          {{attachment.title}}
        </a>
      </div>
    </div>
    
    <div class="nav-items col-12 d-flex flex-wrap justify-content-between">
    <!-- NOTE: Disabled for now, re-enabled if frontpage listing is used
      <router-link :to="{ name: 'frontpage' }" class="back-to-frontpage">
        <button class="btn btn-secondary mx-2">Takaisin aloitussivulle</button>
      </router-link>
    -->
      <!--
      <p class="page-name">{{$t('tuka.navigation.page_name')}} {{ $route.params.componentId }}</p>

      <div class="toggle-banner">
        <button class="btn btn-secondary mx-2" @click="toggleBanner()">
          {{$t('tuka.navigation.view')}}
        </button>
      </div>
       -->
    </div>

  </header>
</template>

<script>
import ChangeLanguage from "./ChangeLanguage";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ComponentGalleryHeader",
  components: {
    ChangeLanguage
  },
  computed: {
    ...mapGetters(["rootItem"]),
  },
};
</script>

<style scoped>
</style>
